/** SPA paths — keep in sync with nginx try_files → index.html. */
export const APP_PATH = {
  home: '/',
  signIn: '/signin',
  signUp: '/signup',
  dashboard: '/dashboard',
  profileCompletion: '/profile-completion',
  wizard: '/wizard',
  methodology: '/methodology',
  terms: '/terms',
};

export function syncAppPath(pathname) {
  if (typeof window === 'undefined') return;
  const next = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (window.location.pathname !== next) {
    window.history.replaceState({}, document.title, next);
  }
}

export function defaultAuthedPath() {
  return APP_PATH.dashboard;
}
